import CreateSport from './class/createSport.js';
import DBHandler from '../index-db/db-handler.js';
import { MergeObjects, Timestamp } from '../utils/utils.js';
import { convert_match_class, Clock_Settings, Match_Players, Player, Push_Match, SportSettingValidation } from './class/coreSport.js';
import { UsingLock, removeCircularReferences } from '../utils/utils.js';
import { LOCKS } from '../services/globalVars.js';
import Sport_Common_JSON from './json-config/common-json.js';
import Sport_Squash_JSON from './json-config/squash-json.js';
import Sport_Pickleball_JSON from './json-config/pickleball-json.js';
import Sport_Padel_JSON from './json-config/padel-json.js';
import Sport_Tennis_JSON from './json-config/tennis-json.js';
import Sport_Scoring21_JSON from './json-config/scoring21-json.js';
import Sport_Racketlon_JSON from './json-config/racketlon-json.js';


const merge_sports = (sport_1, sport_2) => {
   for (const key_1 in sport_1) {
      if (Object.hasOwnProperty.call(sport_1, key_1)) {
         for (const key_2 in sport_2) {
            if (Object.hasOwnProperty.call(sport_2, key_2)) {
               if (key_1 === key_2) {
                  for (const item1 in sport_1[key_1]) {
                     if (Object.hasOwnProperty.call(sport_1[key_1], item1)) {
                        for (const item2 in sport_2[key_2]) {
                           if (Object.hasOwnProperty.call(sport_2[key_2], item2)) {
                              if (item1 === item2) {
                                 if (typeof sport_1[key_1][item1] === 'object') {
                                    if (typeof sport_1[key_1][item1].length !== 'undefined') {
                                       sport_1[key_1][item1] = sport_1[key_1][item1].concat(sport_2[key_2][item2]);
                                    }
                                 }
                              }
                           }
                        }
                     }
                  }
               }
            }
         }
      }
   }
   return sport_1;
}

class SportLoader {
   sport_name = 'Squash';
   sport_object;

   constructor(init = false, sport_name = 'Squash') {
      this.sport_name = sport_name;
      if (init === true) {
         let mergedSport_JSON = {};
         // console.log('SportType pram: ', sport_name);
         // console.log('SportType: ', this.sport_name);

         if (this.sport_name === 'Squash') {
            mergedSport_JSON = merge_sports(JSON.parse(JSON.stringify(Sport_Squash_JSON)), JSON.parse(JSON.stringify(Sport_Common_JSON)));
         } else if (this.sport_name === 'Pickleball') {
            mergedSport_JSON = merge_sports(JSON.parse(JSON.stringify(Sport_Pickleball_JSON)), JSON.parse(JSON.stringify(Sport_Common_JSON)));
         } else if (this.sport_name === 'Padel') {
            mergedSport_JSON = merge_sports(JSON.parse(JSON.stringify(Sport_Padel_JSON)), JSON.parse(JSON.stringify(Sport_Common_JSON)));
         } else if (this.sport_name === 'Tennis') {
            mergedSport_JSON = merge_sports(JSON.parse(JSON.stringify(Sport_Tennis_JSON)), JSON.parse(JSON.stringify(Sport_Common_JSON)));
         } else if (this.sport_name === 'Scoring21') {
            mergedSport_JSON = merge_sports(JSON.parse(JSON.stringify(Sport_Scoring21_JSON)), JSON.parse(JSON.stringify(Sport_Common_JSON)));
         } else if (this.sport_name === 'Racketlon') {
            mergedSport_JSON = merge_sports(JSON.parse(JSON.stringify(Sport_Racketlon_JSON)), JSON.parse(JSON.stringify(Sport_Common_JSON)));
         } else {
            mergedSport_JSON = Sport_Common_JSON;
         }
         this.store_sport_config = JSON.parse(JSON.stringify(mergedSport_JSON));

         // this.sport_object = new CreateSport(JSON.parse(JSON.stringify(mergedSport_JSON)));
         this.set_default_state();
      }
   }

   set_default_state = () => {
      this.sport_object = new CreateSport(JSON.parse(JSON.stringify(this.store_sport_config)));
   }

   check_dependencies = (sportSetting) => {
      return this.sport_object.check_sport_setting_dependencies(sportSetting);
   }

   run_element_fun = (elementObj, funObj) => {
      return this.sport_object.run_element_fun(elementObj, funObj);
   }

   initMatchCode = () => {
      return `MC_${this.sport_object.sport_initial}${Math.floor((1 + Math.random()) * 0x10000000)}`;
   }

   filterSettings = (elementObj) => {
      let elements = [];
      this.sport_object.map(elementObj, (item) => {
         let APPLY = true;
         if (typeof item.value.dep !== 'undefined' && item.value.dep.length > 0) {
            const dep_result = this.check_dependencies(item.value);
            APPLY = dep_result.result;
         }
         if (APPLY) {
            elements.push((item.value));
         }
      });
      return elements;
   }

   buildElement = (elementObj, changedElement = null) => {
      let elements = [];

      this.sport_object.map(elementObj, (item) => {
         if (typeof item.value.fun !== 'undefined' && item.value.fun.length > 0) {
            for (let a = 0; a < item.value.fun.length; a++) {
               if (item.key === changedElement) {
                  this.run_element_fun(item, item.value.fun[a]);
               }
            }
         }
      });

      this.sport_object.map(elementObj, (item) => {
         let APPLY = true;
         if (typeof item.value.dep !== 'undefined' && item.value.dep.length > 0) {
            const dep_result = this.check_dependencies(item.value);
            APPLY = dep_result.result;
         }

         if (APPLY) {
            elements.push((item.value.jsx.build_jsx()));
         }
      });


      return elements;
   }


   validate_sport_setting = (setting) => {
      try {
         let validation_result = null; 
         const setting_obj = this.sport_object.settings[setting];
         const sport_dep_result = this.check_dependencies(setting_obj);
         if (sport_dep_result.result === true) {
            if (typeof setting_obj.validation === 'object') {
               const current_value = setting_obj.value;
               for (let a = 0; a < setting_obj.validation.length; a++) {
                  const setting_val = setting_obj.validation[a].setting;
                  const message = setting_obj.validation[a].message;
                  const condition_setting = this.sport_object.settings[setting_val];
                  const dep_result = this.check_dependencies(condition_setting);
                  if (typeof condition_setting !== 'undefined') {
                     switch (setting_obj.validation[a].type) {
                        case 'must_be_lesser_than_setting':
                           if (dep_result.result && current_value >= condition_setting.value) {
                              validation_result = new SportSettingValidation({ setting: setting_val, validation: setting_obj.validation[a], message: message });
                           }
                           break;
                        case 'must_be_grater_than_setting':
                           if (dep_result.result && current_value <= condition_setting.value) {
                              validation_result = new SportSettingValidation({ setting: setting_val, validation: setting_obj.validation[a], message: message });
                           }
                           break;
                        case 'must_be_grater_or_equal_to_setting':
                           if (dep_result.result && current_value < condition_setting.value) {
                              validation_result = new SportSettingValidation({ setting: setting_val, validation: setting_obj.validation[a], message: message });
                           }
                           break;
                        case 'must_be_lesser_or_equal_to_setting':
                           if (dep_result.result && current_value > condition_setting.value) {
                              validation_result = new SportSettingValidation({ setting: setting_val, validation: setting_obj.validation[a], message: message });
                           }
                           break;

                        default:
                           console.warn('Setting Validation Type Not Found: ', setting_obj.validation[a].type);
                           break;
                     }
                  } else { 
                     console.warn('validate_sport_setting - Setting Not Found: ', setting_val); 
                  }
               }
            }
         }
         return validation_result;
      } catch (error) {
         console.error('SportLoader - validate_sport_setting: ', error);
         return null;
      }
   }


   setupValidate = (fromValues = null) => {
      try {
         const validation_result = [];
         // console.warn('>>> setupValidate <<<');
         this.sport_object.update_settings_from_form(fromValues);
         const settings = this.sport_object.settings;
         for (const key in settings) {
            if (Object.prototype.hasOwnProperty.call(settings, key)) {
               if (typeof settings[key].validation === 'object') {
                  const result = this.validate_sport_setting(key);
                  if (result !== null) {
                     validation_result.push(result);
                  }
               }
            }
         }
   
         return validation_result;
      } catch (error) {
         console.error('SportLoader - setupValidate: ', error);
         return [];
      }
   }

   setupBuild = (fromValues = null, changedElement = null, type = 'new') => {
      try {
         this.sport_object.update_settings_from_form(fromValues);
         const settings = this.sport_object.settings;

         // >>> Hide Settings that are marked as hidden from mod
         if (type === 'mod') {
            for (const key in settings) {
               if (Object.prototype.hasOwnProperty.call(settings, key)) {
                  if (settings[key]?.hide_from_mod === true) {
                     settings[key].hidden = true;
                  }
               }
            }
         }

         const elements = this.buildElement(settings, changedElement);
         const key = 'SportKey';
         return (<div className='sportMenu' key={key} style={{ width: '100%', display: 'flex', flexFlow: 'column', alignItems: 'center' }}>{elements.map(item => item)}</div>)
      } catch (error) {
         console.error('SportLoader - setupBuild: ', error);
         return (<></>)
      }
   }

   validate_unset_settings = (settings) => {
      const settingsConfig = JSON.parse(JSON.stringify(this.store_sport_config.settings));
      this.sport_object.map(settingsConfig, (item) => {
         for (const key in settings) {
            if (Object.hasOwnProperty.call(settings, key)) {
               if (key === item.key && typeof item.value.validation !== 'undefined') {
                  const valIndex = item.value.validation.findIndex(i => i.type === 'un_set');
                  if (valIndex !== -1 && settings[key] === '') {
                     settings[key] = item.value.validation[valIndex].value;
                  }
               }
            }
         }
      });
      return settings;
   }

   get_player_settings = (settings) => {
      const player_map = [];
      const players_Obj = new Match_Players();
      this.sport_object.map(JSON.parse(JSON.stringify(this.store_sport_config.settings)), (item) => {
         if (item.value.special_type === 'player') {
            player_map.push({
               key: item.key,
               side: item.value.link.value,
               sub_color: item.value.sub_value.name,
            });
         }
      });
      for (let a = 0; a < player_map.length; a++) {
         let player_name = '';
         let player_color = '';
         const side = player_map[a].side;
         for (const key in settings) {
            if (Object.hasOwnProperty.call(settings, key)) {
               if (player_map[a].key === key) {
                  player_name = settings[key];
               }
               if (player_map[a].sub_color === key) {
                  player_color = settings[key];
               }
            }
         }
         if (player_name !== '') {
            const player = new Player({ display_name: player_name, color: player_color });
            // if (players_Obj.teams[side - 1].name === '') {
            //    players_Obj.teams[side - 1].name = player_name;
            // }
            players_Obj.teams[side - 1].players.push(player);
         }
      }
      return players_Obj;
   }

   get_color_settings = () => {
      const player_color = [];
      const settingsConfig = JSON.parse(JSON.stringify(this.store_sport_config.settings));
      this.sport_object.map(settingsConfig, (item) => {
         if (typeof item.value.sub_value !== 'undefined') {
            if (item.value.sub_value.type === 'player_color') {
               player_color.push({
                  name: item.value.name,
                  value: item.value.sub_value.value
               });
            }
         }
      });
      return player_color;
   }


   initMatch = (settings, match_code = null, push_match = null, match_players = null) => {
      return new Promise(async (resolve) => {
         console.log('initMatch - settings: ', settings);

         // >>> New Function to reset all states to their default values before creating a new match.....
         this.set_default_state();

         settings = this.validate_unset_settings(settings);
         const players = this.get_player_settings(settings);
         // console.log('>>> initMatch ', settings);
         // console.log('>>> players ', players);

         // const match = new Match({
         const match = convert_match_class(this.sport_name,{
            sport: this.sport_name,
            match_code: match_code === null ? this.initMatchCode() : match_code,
            push_match: push_match === null ? new Push_Match() : push_match,
            match_state: 'init',
            settings: settings,
            players: match_players === null ? players : match_players,
            synced: 0,
            mid: 0,
         });

         // >>> Check if the match is a hot load
         match.check_hot_load();

         // >>> Reset and Save Clocks
         this.sport_object.init_self_clocks(JSON.parse(JSON.stringify(this.store_sport_config.clocks)));
         for (let a = 0; a < this.sport_object.clocks.length; a++) {
            await this.saveClock(this.sport_object.clocks[a])
         }
         // >>> Config Serving State
         const serving_config = JSON.parse(JSON.stringify(this.store_sport_config.scoring.serving));
         const setup_config = this.fresh_setup_config();
         const matchType = this.sport_object.settings.match_type.options[parseInt(settings.match_type) - 1].label.toLowerCase();
          this.sport_object.scoring.state.updateState(this.sport_object.sport_name, { serving_config: serving_config, sport_config: this.sport_object.settings, setup_config: setup_config, matchType: matchType, player: 1 });
         await this.saveGameState('initMatch');
         const dbHandler = DBHandler();
         await dbHandler.init();
         const match_id = await dbHandler.initMatch(match);
         await dbHandler.update_app_state({ app_state: 'match', game_state: 'warmup', match_id: match_id }, 'initMatch');

         // console.log('>>>>>>>>>>>>>> match_id: ', match_id)

         resolve(true)
      });
   }

   modMatch = (settings) => {
      return new Promise(async (resolve) => {
         settings = this.validate_unset_settings(settings);
         const players = this.get_player_settings(settings);
         const match = JSON.parse(JSON.stringify(this.sport_object.scoring.state.match));
         match.settings = settings;
         match.players = players;

         const matchType = this.sport_object.settings.match_type.options[parseInt(settings.match_type) - 1].label.toLowerCase();
         await this.sport_object.scoring.state.updateState(this.sport_object.sport_name, { sport_config: this.sport_object.settings, matchType: matchType });
         const dbHandler = DBHandler();
         await dbHandler.init();
         await this.saveGameState('modMatch');
         await this.saveMatch(match.id, match, 'modMatch');
         this.updateGameStateTimestamp();
         resolve(true)
      });
   }

   saveMatch = async (matchID, matchObj, tag = 'Not Set') => {
      await UsingLock(LOCKS.update_match_lock, async () => {
         if (matchObj.games.length === 0) { console.error('ERROR, This needs to be looked at'); }
         const dbHandler = DBHandler();
         await dbHandler.updateMatch(matchID, matchObj, 'saveMatch-' + tag);
      });
   }
   
   saveActiveMatch = async () => {
      return new Promise(async (resolve) => {
         try {
            // Capture the match state BEFORE waiting for the lock
            // This prevents other code from modifying the in-memory object while we wait
            const active_match = JSON.parse(JSON.stringify(this.sport_object.scoring.state.match));
            
            await UsingLock(LOCKS.update_match_lock, async () => {
               const dbHandler = DBHandler();
               await dbHandler.updateMatch(active_match.id, active_match, 'saveActiveMatch');
               resolve(true);
            });
         } catch (error) {
            console.error('SportLoader - saveActiveMatch: ', error);
            resolve(false);
         }
      });
   }




   loadMatch = (match_id) => {
      return new Promise(async (resolve) => {
         try {
            const dbHandler = DBHandler();
            const match = await dbHandler.loadMatch(match_id); 
            resolve(match);
         } catch (error) {
            console.error('SportLoader - loadMatch: ', error);
            resolve(false);
         }
      });
   }

   saveSpecificState = (link, setting) => {
      return new Promise(async (resolve) => {
         try {
            const dbHandler = DBHandler();
            const appState = await dbHandler.load_app_state();
            const mergedConfig = MergeObjects(appState.config, link, setting);
            if (mergedConfig !== false) {
               await dbHandler.update_app_state({
                  config: mergedConfig
               });
            }
            resolve(true);
         } catch (error) {
            console.error('SportLoader - saveSpecificState: ', error);
            resolve(false);
         }
      });
   }

   saveGameState = (caller) => {
      return new Promise(async (resolve) => {
         try {
            // console.warn('*----------------saveGameState - '+caller+': ');
            const dbHandler = DBHandler();
            
            // Capture state BEFORE any async operations to prevent race conditions
            const warmup_state = JSON.parse(JSON.stringify(this.sport_object.warmup.state));
            const scoring_state = JSON.parse(JSON.stringify(removeCircularReferences(this.sport_object.scoring.state)));
            
            // Extract and capture match BEFORE waiting for locks
            let matchToSave = null;
            let matchID = null;
            if (typeof scoring_state.match !== 'undefined') {
               matchToSave = JSON.parse(JSON.stringify(scoring_state.match));
               matchID = matchToSave.id;
               delete scoring_state.match;
               delete matchToSave.id;
            }

            // Now save the captured match state
            if (matchToSave !== null && matchID !== null) {
               await this.saveMatch(matchID, matchToSave, 'saveGameState');
            }
            const config = {
               warmup_state: warmup_state,
               scoring_state: scoring_state,
            }

            await dbHandler.update_app_state({
               config: config
            });
            resolve(true);
         } catch (error) {
            console.error('SportLoader - saveGameState: ', error);
            resolve(false);
         }
      });
   }

   loadGameState = (match_id = null) => {
      return new Promise(async (resolve) => {
         try {
            const dbHandler = DBHandler();
            const appState = await dbHandler.load_app_state();
            if (match_id === null) {
               match_id = appState.match_id;
            }
            if (typeof match_id !== 'undefined') {
               const match = await this.loadMatch(match_id);
               this.sport_object.update_settings_from_form(match.settings);
               // appState.config.scoring_state.match = new Match(match);
               appState.config.scoring_state.match = convert_match_class(this.sport_name, match);

               // const settings = this.validate_unset_settings(match.settings);
               this.sport_object.warmup.state = appState.config.warmup_state;
               this.sport_object.load_scoring_state(appState.config.scoring_state);
            }

            // >>> Load All Saved Clocks
            await this.loadClocks();
            
            resolve(true);
         } catch (error) {
            console.error('SportLoader - loadGameState: ', error);
            resolve(false);
         }
      });
   }

   updateGameStateTimestamp = () => {
      return new Promise(async (resolve) => {
         try {
            const dbHandler = DBHandler();
            await dbHandler.update_app_state({
               update: Timestamp()
            });
            resolve(true);
         } catch (error) {
            console.error('SportLoader - updateGameStateTimestamp: ', error);
            resolve(false);
         }
      });
   }

   saveClock = (clock) => {
      return new Promise(async (resolve) => {
         try {
            const dbHandler = DBHandler();
            await dbHandler.saveClock(clock.id, clock);
            resolve(true);
         } catch (error) {
            console.error('SportLoader - saveClock: ', error);
            resolve(false);
         }
      });
   }

   loadClocks = () => {
      return new Promise(async (resolve) => {
         try {
            const dbHandler = DBHandler();
            
            for (let a = 0; a < this.sport_object.clocks.length; a++) {
               const loadedClock = await dbHandler.loadClock(this.sport_object.clocks[a].id);
               if (typeof loadedClock !== 'undefined') {
                  this.sport_object.clocks[a] = new Clock_Settings(loadedClock.clock);
               }
            }
            resolve(true);
         } catch (error) {
            console.error('SportLoader - loadClocks: ', error);
            resolve(false);
         }
      });
   }

   getClock = (clock_id) => {
      let result;
      const clockIndex = this.sport_object.clocks.findIndex(clock => clock.id === clock_id);
      if (clockIndex !== -1) {
         result = this.sport_object.clocks[clockIndex];
      }
      return result;
   }

   check_continuous_clock = () => {
      const depTest = this.check_dependencies(this.store_sport_config.scoring.continuous_clock)
      return depTest.result === true ? true : false;
   }

   fresh_setup_config = () => {
      return JSON.parse(JSON.stringify(this.store_sport_config.setup));;
   }

}

export default SportLoader;